import React, { useState } from "react";
import { PiXFill } from "react-icons/pi";
import { putApi } from "../../../../services/api/globalApi";
import Button from "../../button/Button";
import { successMessage } from "../../../../utils/toastify-message/ToastifyMessage";
import { useNavigate } from "react-router";

const { forwardRef, useRef, useImperativeHandle } = React;

const ExportModal = forwardRef(({ productData,reGetData }, ref) => {
  const [showModal, setShowModal] = useState(false);
  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
    },
    afterSubmit() {},
  }));

  const navigate = useNavigate();

  const formHandler = async (print) => {
    try {
      const path = `admin/orders/${productData._id}/exported`;
      const body = {
        exported: true,
      };
      await putApi({ path, body });
      successMessage("سفارش با موفقیت تایید شد");
      setShowModal(false);
      if (print) {
        navigate(`/pdf-and-print?orderId=${encodeURIComponent(productData._id)}`, {
          state: productData,
        });
      }
      reGetData()
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-[340px] sm:w-[800px] py-4 max-h-[360px] overflow-y-scroll bg-white mt-4 shadow-md z-40 rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-170px] sm:mr-[-400px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div className="w-full px-6 flex items-center justify-between py-4 border-b-2">
          <h4>تایید سفارش</h4>
          <PiXFill
            onClick={() => setShowModal(false)}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>
        <div className="w-11/12 mx-auto py-8 text-center w-full">
          آیا شما سفارش {productData?.trackingCode} رو تایید میکنید؟
        </div>
        <div className="flex gap-2 justify-end w-full">
          <Button
            onClick={() => formHandler(true)}
            text={"تایید و پرینت سفارش"}
            color={"primary"}
            type="button"
          />
          <Button
            onClick={() => formHandler(false)}
            text={"تایید سفارش"}
            color={"success"}
          />
        </div>
      </div>
    </>
  );
});
export default ExportModal;
